// A job's review as LineTable's columns (BL-189 consolidation; was CompareTable): each item sold, billed
// and used side by side, so a gap shows as a red word in its row ("missing · see 1") pointing at the fix
// above it; the foot totals what was sold and billed and says what's short. It draws a CompareView
// (job-view.ts), so a cost is in its foot only when the view has one: the owner's.
import type { LineTableProps } from '../components/LineTable/LineTable.tsx';
import type { CompareView } from '../job-page/job-view.ts';

/** Sold, billed and used, as LineTable draws them. */
export function compareLines(compare: CompareView): LineTableProps {
  return {
    label: 'Sold, billed and used',
    columns: [
      { id: 'item', label: 'Item' },
      { id: 'sold', label: 'Sold', sub: compare.soldSub, align: 'end' },
      { id: 'billed', label: 'Billed', sub: compare.billedSub, align: 'end' },
      { id: 'used', label: 'Used', sub: 'from' },
    ],
    rows: compare.rows.map((r) => ({
      id: r.id,
      cells: { item: r.item, sold: r.sold, billed: r.billed, used: r.used },
    })),
    foot: {
      item: 'Total',
      sold: compare.foot.sold,
      billed: compare.foot.billed,
      used: compare.foot.used,
    },
  };
}
